import React from "react";
import "./PickemBlankPage.scss";

export const PickemBlankPage = ({ children }) => {
  return (
    <div className="PickemBlankPage">{children}</div>
  );
};
